/**
 * The Supabase client, fetched as its own file the first time it is needed.
 *
 * supabase-js is about 175 KB of the old entry bundle (auth, realtime,
 * storage, postgrest), and none of it runs before the first paint: the page
 * only needs it to read site settings and sign-in state a moment later.
 * Importing it statically put all of it ahead of React in the download and in
 * the parse, which is what PageSpeed reported as unused JavaScript.
 *
 * Code that is only reachable from the entry bundle (the auth provider, the
 * navbar's settings, testimonials) goes through this. Pages loaded as their
 * own chunks keep importing "@/lib/supabase" directly: the module is a
 * singleton, so both routes get the same client.
 */
export const loadSupabase = () => import("@/lib/supabase").then((m) => m.supabase);
